import React, { useEffect, useState } from 'react';
import withCGI from '../../common/cgi/Cgi';
import { combineClassNames } from 'core/css';

export const noImageLargeSrc = () =>
  `${window.UI_PATH || ''}/assets/images/no-image-large.jpg`;

export const BottomNavCGI = (props) => {
  const { classIdentifier, image, analyticsKey } = props;
  const [src, setSrc] = useState(image);

  useEffect(() => {
    setSrc(image);
  }, [image]);

  const onError = () => {
    const fallback = noImageLargeSrc();
    setSrc((current) => (current === fallback ? current : fallback));
  };

  return (
    <div
      className={
        classIdentifier
          ? combineClassNames([
              `${classIdentifier}__more-views__vehicle-jelly`,
              'more-views__vehicle-jelly',
            ])
          : 'more-views__vehicle-jelly'
      }>
      <img
        className={`
          ${
            classIdentifier
              ? combineClassNames([
                  `${classIdentifier}__more-views__vehicle-img`,
                  'more-views__vehicle-img',
                  'stat-image-link',
                ])
              : 'more-views__vehicle-img stat-image-link'
          }`}
        data-dtm={analyticsKey}
        alt="vehicle configuration"
        src={src}
        onError={onError}
      />
    </div>
  );
};

export default withCGI(BottomNavCGI);
